/**
 * useAIStatus – bestaat de AI-functie (LLM) voor deze gebruiker? (#657)
 *
 * De enige bron is GET /ai/status (backend: orion_core/services/llm_toegang.py). Geen eigen
 * afleiding uit rol, tier of features: de backend beslist, ook voor admins. Zolang het antwoord
 * er niet is, of bij een fout, telt AI als uit (knoppen verborgen, geen 403 bij de klik).
 */
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'

export const AI_STATUS_QUERY_KEY = ['ai-status']

export function useAIStatus({ refetchInterval } = {}) {
  const { data, isLoading } = useQuery({
    queryKey: AI_STATUS_QUERY_KEY,
    queryFn: async () => (await api.get('/ai/status')).data,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchInterval,
  })
  return {
    aiEnabled: data?.ai_enabled === true,
    reden: data?.reden ?? null,
    melding: data?.melding ?? null,
    status: data,
    isLoading,
  }
}

export default useAIStatus
